"use client";

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import BrainMobileAbout from "./BrainMobileAbout";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import type { ApiWave } from "@/generated/models/ApiWave";
import MyStreamWaveLeaderboard from "../my-stream/MyStreamWaveLeaderboard";
import MyStreamWaveSubmissions from "../my-stream/MyStreamWaveSubmissions";
import MyStreamWaveOutcome from "../my-stream/MyStreamWaveOutcome";
import MyStreamWaveSales from "../my-stream/MyStreamWaveSales";
import MyStreamWaveMyVotes from "../my-stream/votes/MyStreamWaveMyVotes";
import MyStreamWaveFAQ from "../my-stream/MyStreamWaveFAQ";
import BrainMobileWaves from "./BrainMobileWaves";
import BrainMobileMessages from "./BrainMobileMessages";
import BrainNotifications from "../notifications/NotificationsContainer";
import { WaveWinners } from "@/components/waves/winners/WaveWinners";
import { BrainView } from "./brainMobileViews";
interface BrainMobileViewContentProps {
  readonly activeView: BrainView;
  readonly activeWaveId: string | null;
  readonly children: ReactNode;
  readonly isCurationWave: boolean;
  readonly isMemesWave: boolean;
  readonly isRankWave: boolean;
  readonly isApproveWave?: boolean | undefined;
  readonly onDropClick: (drop: ExtendedDrop) => void;
  readonly onOpenQuickVote: () => void;
  readonly onPrefetchQuickVote?: (() => void) | undefined;
  readonly wave: ApiWave | null | undefined;
}
export default function BrainMobileViewContent(t0) {
  const $ = _c(38);
  const {
    activeView,
    activeWaveId,
    children,
    isCurationWave,
    isMemesWave,
    isRankWave,
    isApproveWave: t1,
    onDropClick,
    onOpenQuickVote,
    onPrefetchQuickVote,
    wave
  } = t0;
  const isApproveWave = t1 === undefined ? false : t1;
  const isCompetitionWave = isRankWave || isApproveWave;
  const supportsOutcomeView = isCompetitionWave && !isCurationWave;
  const rankWave = isCompetitionWave ? wave ?? null : null;
  const outcomeWave = supportsOutcomeView ? wave ?? null : null;
  const curationWave = isCurationWave ? wave ?? null : null;
  const faqWave = isMemesWave ? wave ?? null : null;
  let t2;
  if ($[0] !== onDropClick || $[1] !== rankWave) {
    t2 = rankWave ? <MyStreamWaveLeaderboard key={rankWave.id} wave={rankWave} onDropClick={onDropClick} /> : null;
    $[0] = onDropClick;
    $[1] = rankWave;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const leaderboardContent = t2;
  let t3;
  if ($[3] !== onDropClick || $[4] !== rankWave) {
    t3 = rankWave ? <MyStreamWaveSubmissions key={rankWave.id} wave={rankWave} onDropClick={onDropClick} /> : null;
    $[3] = onDropClick;
    $[4] = rankWave;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const submissionsContent = t3;
  let t4;
  if ($[6] !== curationWave) {
    t4 = curationWave ? <MyStreamWaveSales waveId={curationWave.id} /> : null;
    $[6] = curationWave;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const salesContent = t4;
  let t5;
  if ($[8] !== onDropClick || $[9] !== rankWave) {
    t5 = rankWave ? <div className="tw-px-2 sm:tw-px-4"><WaveWinners wave={rankWave} onDropClick={onDropClick} /></div> : null;
    $[8] = onDropClick;
    $[9] = rankWave;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const winnersContent = t5;
  let t6;
  if ($[11] !== outcomeWave) {
    t6 = outcomeWave ? <MyStreamWaveOutcome wave={outcomeWave} /> : null;
    $[11] = outcomeWave;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const outcomeContent = t6;
  let t7;
  if ($[13] !== onDropClick || $[14] !== rankWave) {
    t7 = rankWave ? <MyStreamWaveMyVotes wave={rankWave} onDropClick={onDropClick} /> : null;
    $[13] = onDropClick;
    $[14] = rankWave;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const myVotesContent = t7;
  let t8;
  if ($[16] !== faqWave) {
    t8 = faqWave ? <MyStreamWaveFAQ wave={faqWave} /> : null;
    $[16] = faqWave;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const faqContent = t8;
  let t9;
  if ($[18] !== children) {
    t9 = <>{children}</>;
    $[18] = children;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== activeWaveId) {
    t10 = <BrainMobileAbout activeWaveId={activeWaveId} />;
    $[20] = activeWaveId;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== onOpenQuickVote || $[23] !== onPrefetchQuickVote) {
    t11 = <BrainMobileWaves onOpenQuickVote={onOpenQuickVote} onPrefetchQuickVote={onPrefetchQuickVote} />;
    $[22] = onOpenQuickVote;
    $[23] = onPrefetchQuickVote;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <BrainMobileMessages />;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <BrainNotifications />;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== faqContent || $[28] !== leaderboardContent || $[29] !== myVotesContent || $[30] !== outcomeContent || $[31] !== salesContent || $[32] !== submissionsContent || $[33] !== t10 || $[34] !== t11 || $[35] !== t9 || $[36] !== winnersContent) {
    t14 = {
      [BrainView.DEFAULT]: t9,
      [BrainView.ABOUT]: t10,
      [BrainView.LEADERBOARD]: leaderboardContent,
      [BrainView.SUBMISSIONS]: submissionsContent,
      [BrainView.SALES]: salesContent,
      [BrainView.WINNERS]: winnersContent,
      [BrainView.OUTCOME]: outcomeContent,
      [BrainView.MY_VOTES]: myVotesContent,
      [BrainView.FAQ]: faqContent,
      [BrainView.WAVES]: t11,
      [BrainView.MESSAGES]: t12,
      [BrainView.NOTIFICATIONS]: t13
    };
    $[27] = faqContent;
    $[28] = leaderboardContent;
    $[29] = myVotesContent;
    $[30] = outcomeContent;
    $[31] = salesContent;
    $[32] = submissionsContent;
    $[33] = t10;
    $[34] = t11;
    $[35] = t9;
    $[36] = winnersContent;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  const contentByView = t14;
  return contentByView[activeView];
}